import { z } from 'zod'

export const ShiftsDeleteSchema = () => {
  return z.object({
    startAt: z.date(),
    endAt: z.date(),
    employeeId: z.number().nullable(),
    employeeSelection: z.discriminatedUnion('type', [
      z.object({
        type: z.literal('manual'),
        ids: z.array(z.string()),
      }),
      z.object({
        type: z.literal('all'),
        filters: z.record(z.unknown()).optional(),
        excludedIds: z.array(z.string()),
        includeInactive: z.boolean().optional(),
      }),
    ]),
  })
}

export type ShiftsDeleteSchemaType = z.infer<ReturnType<typeof ShiftsDeleteSchema>>
